import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, pairwise, take, takeUntil } from 'rxjs/operators';

import {
  MaintenanceBypassService,
  MaintenanceService,
} from '@customer-portal/core';

export const maintenanceCancellationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const maintenanceService = inject(MaintenanceService);
  const maintenanceBypassService = inject(MaintenanceBypassService);

  return next(req).pipe(
    takeUntil(
      maintenanceService.maintenance$.pipe(
        pairwise(),
        filter(
          ([prev, curr]) => !(prev?.active ?? false) && (curr?.active ?? false),
        ),
        filter(() => !maintenanceBypassService.isBypassed()),
        take(1),
      ),
    ),
  );
};
